import { BubbleHero, BubbleContentWrapper } from './bubble-hero'

export { BubbleContentWrapper }
export default BubbleHero
